import React from 'react';
import { motion } from 'framer-motion';
export const AboutCreator = () => {
  return <section className="bg-white px-4 py-10 md:py-20 lg:px-8" data-id="element-14">
      <div className="mx-auto max-w-6xl" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-16">
          <h2 className="font-serif text-3xl font-bold text-text-dark md:text-4xl" data-id="element-17">
            Not a fan of leftovers or soggy freezer meals? Me neither.
          </h2>
        </motion.div>

        <div className="flex flex-col items-center gap-12 md:flex-row md:items-start" data-id="element-18">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full md:w-auto md:flex-shrink-0" data-id="element-19">
            <div className="mx-auto max-w-sm md:max-w-xs" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/j9EphzCZnHdtgiDF2S3Vvw/mujer.jpg" alt="Jen, creator of Peaceful Dinner Protocol" className="w-full rounded-2xl shadow-lg object-cover" data-id="element-21" />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6 text-lg leading-relaxed text-text-dark" data-id="element-22">
            <p data-id="element-23">
              I'll be honest: when I first started freezer prepping, I grabbed
              recipes from random places online. Most weren't great. The
              vegetables turned to mush and the meat stayed dry.
            </p>
            <p data-id="element-24">
              I knew the method could work, but the recipes out there were
              mediocre. That's exactly why I created my own system. We prep
              these meals raw, which means they aren't reheated leftovers—they
              are fresh, high-quality dinners every single time you cook them.
            </p>
            <p data-id="element-25">
              Every recipe is freezer-optimized. I test them countless times to
              ensure they're spectacular by the time they reach you. I'm not a
              chef—I'm a mom obsessed with efficiency. My name is Jen, and I
              want you to take back your evenings too. I went from crying in
              front of an open fridge to having a full month of dinners ready in
              just 4 hours, and today, I want to give you the key to my system
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};